// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__2sIAj","logo":"Navbar_logo__2wEkx"};